'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Constants = require('constants/Constants');
const Events = require('constants/Events');

const IndexTailoredGreenSvg = require('components/Index/IndexTailored/IndexTailoredGreenSvg/IndexTailoredGreenSvg');

require('./IndexTailored.less');

const Selectors = {
    el: '.IndexTailored',
    title: '.IndexTailored-title',
    items: '.IndexTailored-item',
    itemTitle: '.IndexTailored-itemTitle',
    itemDescription: '.IndexTailored-itemDescription',
    textWrapper: '.IndexTailored-textWrapper',
    sequenceWrapper: '.IndexTailored-sequenceWrapper',
    sequenceWrapperInner: '.IndexTailored-sequenceWrapper-inner',
    sequenceVideoOrImg: '.IndexTailored-sequenceWrapper video, .IndexTailored-sequenceWrapper img',
    svg: '.IndexTailoredGreenSvg'
};

const BindFunctions = [
    'onScroll',
    'setItemActive',
    '_initVariables',
    'splitBlockTextToLines',
    'onResize',
    'activateVideoBlock',
    'progressVideo',
    'initBlocks',
    'setLastPosition',
    'canVideoBeAutoPlayed'
];

const animateTextByLinesConfig = {
    lineDuration: 1000,
    lineDelay: 30,
    shift: 30
};

const animateTextByLinesReverseConfig = {
    ...animateTextByLinesConfig,
    backwards: true
};

const VideoDurations = [
    1.667,
    2.17,
    3.17,
    2.184
];

const VideoSequenceNamePattern = 'tailor_';

const ChildViews = {
    'IndexTailoredGreenSvg': {
        selector: '.IndexTailoredGreenSvg',
        viewConstructor: IndexTailoredGreenSvg
    }
};

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);
        this._initVariables();
        this.viewsRegistration(ChildViews);

        setTimeout(() => {
            if (this.isMobile) {
                this.$(Selectors.title)
                    .css(Constants.cssProperties.opacity, 1);

                this.$items.removeClass(Constants.cssClasses.isHide);
                this.$el.removeClass(Constants.cssClasses.isHide);
                this.canVideoBeAutoPlayed(app.settings.hasAutoPlay);

                app.vent.on(Events.common.scroll, this.onScroll);
                app.vent.on(Events.common.resize, this.onResize);
                app.vent.on(Events.home.hero.sequenceEnded, this.onResize);
                this.onResize();

                this.$sequenceWrapper.removeClass(Constants.cssClasses.isHide);
            } else {
                this.splitBlockTextToLines();
                this.initBlocks();
            // this.createVideo(app.settings.isIE);
                this.canVideoBeAutoPlayed(app.settings.hasAutoPlay);

                app.vent.on(Events.home.tailored.cardTransitionBottomDown, () => {
                    if (this.state.titleShown) {
                        return;
                    }

                    this.$(Selectors.title)
                        .css(Constants.cssProperties.opacity, 1);
                    app.utils.animateTextByLines(this.titleObj, animateTextByLinesConfig);
                    app.vent.on(Events.common.scroll, this.onScroll);
                    app.vent.on(Events.common.resize, this.onResize);
                    this.onResize();

                    this.state.titleShown = true;
                    this.setItemActive(0);
                    (this.videos[0].video || this.videos[0].img).style.opacity = 0;
                });

                app.vent.on(Events.home.tailored.cardTransitionAfter, () => {
                    this.$el.removeClass(Constants.cssClasses.isHide);
                });

                app.vent.on(Events.home.tailored.cardTransitionBefore, () => {
                    (this.videos[0].video || this.videos[0].img).style.opacity = 0;
                });

                app.vent.on(Events.home.tailored.cardTransitionBottomUp, () => {
                    this.state.titleShown = false;
                    app.utils.animateTextByLines(this.titleObj, animateTextByLinesReverseConfig, () => {
                        if (this.state.titleShown) {
                            return;
                        }
                        this.$(Selectors.title)
                            .css(Constants.cssProperties.opacity, 0);
                    });

                    this.blocks[0].isShown = false;
                    this.blocks[0].isActive = false;

                    if (!this.state.isInitialPositionSet) {
                        (this.videos[0].video || this.videos[0].img).style.opacity = 0;
                        this.setInitialPosition();
                    }

                    this.$el.addClass(Constants.cssClasses.isHide);

                    app.utils.animateTextByLines(this.blocks[0].itemTitleObj, animateTextByLinesReverseConfig, () => {
                        if (!this.blocks[0].isShown && !this.blocks[0].isActive) {
                            this.blocks[0].$title
                                .css(Constants.cssProperties.opacity, 0);
                        }
                    });

                    app.utils.animateTextByLines(this.blocks[0].itemDescriptionObj,
                        animateTextByLinesReverseConfig, () => {
                            if (!this.blocks[0].isShown && !this.blocks[0].isActive) {
                                this.blocks[0].$description
                                    .css(Constants.cssProperties.opacity, 0);
                            }
                        }
                    );

                    app.vent.off(Events.common.scroll, this.onScroll);
                    app.vent.off(Events.common.resize, this.onResize);

                    this.state.blocksShown = [];
                });
            }
        }, 15);
    },

    canVideoBeAutoPlayed: function (hasAutoPlay) {
        this.createVideo(app.settings.isIE || !hasAutoPlay);
        this.onResize();
    },

    splitBlockTextToLines: function () {
        // title
        this.titleObj = {
            $container: this.$(Selectors.title),
            className: 'IndexTailored-titleLine',
            autoWidth: true
        };
        this.$(Selectors.title).css(Constants.cssProperties.opacity, 0);
        app.utils.splitMultilineToSeparateSpans(this.titleObj);

        // items
        this.$items.each((index, item) => {
            const $item = $(item);
            const $itemTitle = $item.find(Selectors.itemTitle);
            const $itemDescription = $item.find(Selectors.itemDescription);

            const itemTitleObj = {
                $container: $itemTitle,
                className: 'IndexTailored-itemTitleLine',
                autoWidth: true
            };

            const itemDescriptionObj = {
                $container: $itemDescription,
                className: 'IndexTailored-itemDescriptionLine',
                autoWidth: true
            };
            $itemTitle.css('opacity', 0);
            $itemDescription.css('opacity', 0);
            app.utils.splitMultilineToSeparateSpans(itemTitleObj);
            app.utils.splitMultilineToSeparateSpans(itemDescriptionObj);
        });
    },

    _initVariables: function () {
        this.$items = this.$(Selectors.items);
        this.countOfItems = this.$items.length;
        this.blockHeight = this.$el.height();
        this.blockOffsetTop = this.$el.offset().top;
        this.state = {
            titleShown: false,
            blocksShown: []
        };
        this.$sequenceWrapper = this.$(Selectors.sequenceWrapper);
        this.$sequenceWrapperInner = this.$(Selectors.sequenceWrapperInner);
        this.videoSequenceAssetsFolder = this.$sequenceWrapper.data('assets-folder');
    },

    initBlocks: function () {
        this.blocks = [];

        this.$items.each((index, item) => {
            const $item = $(item);
            const $title = $item.find(Selectors.itemTitle);
            const $description = $item.find(Selectors.itemDescription);
            const itemTitleObj = {
                $container: $title,
                className: 'IndexTailored-itemTitleLine',
                autoWidth: true
            };

            const itemDescriptionObj = {
                $container: $description,
                className: 'IndexTailored-itemDescriptionLine',
                autoWidth: true
            };

            const block = {
                $el: $item,
                $title,
                $description,
                itemTitleObj,
                itemDescriptionObj,
                isShown: false,
                isActive: false
            };

            this.blocks.push(block);
        });
    },

    setItemActive: function (index) {
        if (this.isMobile) {
            return;
        }

        const currentItem = this.blocks[index];
        const nextItem = this.blocks[index + 1];
        const prevItem = this.blocks[index - 1];

        if (currentItem) {
            if (!currentItem.isActive) {
                currentItem.$el
                    .addClass(Constants.cssClasses.isActive)
                    .removeClass(Constants.cssClasses.isHide);
                currentItem.isActive = true;
            }

            if (!currentItem.isShown) {
                // activate item that matches current index
                currentItem.$title.css(Constants.cssProperties.opacity, 1);
                currentItem.$description.css(Constants.cssProperties.opacity, 1);
                currentItem.isShown = true;

                app.utils.animateTextByLines(currentItem.itemTitleObj, animateTextByLinesConfig);
                app.utils.animateTextByLines(currentItem.itemDescriptionObj, animateTextByLinesConfig);
            }
        }

        if (nextItem && nextItem.isShown) {
            nextItem.$el
                .addClass(Constants.cssClasses.isPendingToHide);

            const titlePromise = new Promise((resolve) => {
                app.utils.animateTextByLines(nextItem.itemTitleObj, animateTextByLinesReverseConfig, () => {
                    if (!nextItem.isActive && !nextItem.isShown) {
                        nextItem.$title.css(Constants.cssProperties.opacity, 0);
                    }
                    resolve();
                });
            });

            const descriptionPromise = new Promise((resolve) => {
                app.utils.animateTextByLines(nextItem.itemDescriptionObj, animateTextByLinesReverseConfig, () => {
                    if (!nextItem.isActive && !nextItem.isShown) {
                        nextItem.$description.css(Constants.cssProperties.opacity, 0);
                    }
                    resolve();
                });
            });

            nextItem.isActive = false;
            nextItem.isShown = false;

            Promise.all([titlePromise, descriptionPromise]).then(() => {
                if (nextItem.isActive || nextItem.isShown) {
                    return;
                }
                nextItem.$el
                    .removeClass(Constants.cssClasses.isActive)
                    .addClass(Constants.cssClasses.isHide)
                    .removeClass(Constants.cssClasses.isPendingToHide);
            });
        }

        if (prevItem && prevItem.isActive) {
            prevItem.$el
                .removeClass(Constants.cssClasses.isActive)
                .removeClass(Constants.cssClasses.isHide);

            prevItem.isActive = false;
        }
    },

    setTranslate: function (index) {
        if (this.isMobile || index < 0) {
            return;
        }

        const moving = -100 * index;
        this.$(Selectors.textWrapper).css(Constants.cssProperties.transform, `translate3d(0, ${moving}px, 0)`);
    },

    onScroll: function (scrollTop) {
        if (!this.videos) {
            return;
        }

        // const maxProgressForLastVideo = 0.99;
        let scroll;
        let singleBlockHeight;
        let activeBlock;
        let progress;
        let opacity;
        const minOpacity = 0.3;

        if (this.isMobile) {
            scroll = scrollTop;

            for (var i = 0; i < this.itemsPos.length; i++) {
                let pos = this.itemsPos[i];
                if (scroll >= pos.start && scroll <= pos.end) {
                    if (scroll <= pos.minOpacityAtStart) {
                        opacity = minOpacity;
                        progress = 0;
                    } else if (scroll <= pos.progressStart) {
                        opacity = 1 - (1 - (scroll - pos.minOpacityAtStart) /
                            (pos.progressStart - pos.minOpacityAtStart)) * (1 - minOpacity);
                        progress = 0;
                    } else if (scroll <= pos.progressEnd) {
                        opacity = 1;
                        progress = (scroll - pos.progressStart) / (pos.progressEnd - pos.progressStart);
                    } else if (scroll <= pos.minOpacityAtEnd) {
                        opacity = 1 - (scroll - pos.progressEnd) /
                            (pos.minOpacityAtEnd - pos.progressEnd) * (1 - minOpacity);
                        progress = 1;
                    } else {
                        opacity = minOpacity;
                        progress = 1;
                    }
                    break;
                }
            }

            activeBlock = i;

            if ((activeBlock === this.itemsPos.length - 1 && progress === 1) ||
                (activeBlock > this.itemsPos.length - 1)) {
                activeBlock = this.itemsPos.length;
                opacity = 1;
                progress = 1;
            }

            if (scroll < this.itemsPos[0].start) {
                activeBlock = -1;
                opacity = minOpacity;
                progress = 0;
            }

            if (opacity !== this.prevMobileOpacity) {
                this.$sequenceWrapperInner[0].style.opacity = opacity;
                this.prevMobileOpacity = opacity;
            }
        } else {
            scroll = scrollTop - this.blockOffsetTop;
            singleBlockHeight = this.blockHeight / (this.countOfItems + 1);
            activeBlock = Math.floor(scroll / singleBlockHeight);
            progress = (scroll - activeBlock * singleBlockHeight) / singleBlockHeight;
        }


        if (this.isMobile && activeBlock < 0) {
            this.progressVideo(0, 0);
        }

        //for last video max progress is set to 0.99, till next active sections progess reaches 0.5
        //to stay on last frame of video there card is still visible and have time to smoothly fade out 3d card above it
        if (activeBlock >= 0 && activeBlock < this.videos.length) {
            this.progressVideo(activeBlock, progress
                // Math.min(progress, activeBlock === this.videos.length - 1 ? maxProgressForLastVideo : 1)
            );
        }

        //to stay on last frame of last video (where is no card above globe)
        if (!this.isMobile && activeBlock === this.videos.length) {
            this.progressVideo(activeBlock - 1, 1);
        }

        const isSvgVisible = (activeBlock === this.videos.length - 1 && progress > 0.65)
            || (activeBlock > this.videos.length - 1 && (activeBlock < this.videos.length + 2));
        if (isSvgVisible !== this.isSvgVisible) {
            this.$(Selectors.svg).toggleClass(Constants.cssClasses.isShow, isSvgVisible);
            this.isSvgVisible = isSvgVisible;
        }

        if (activeBlock < this.countOfItems - 1 && this.state.isLastPositionSet) {
            this.state.isLastPositionSet = false;
        }

        if (activeBlock >= 0 && this.state.isInitialPositionSet) {
            this.state.isInitialPositionSet = false;
        }

        if (this.state.isLastPositionSet || this.state.isInitialPositionSet) {
            return;
        }

        if (activeBlock >= this.countOfItems - 1) {
            this.setLastPosition();
        }

        if (this.state.blockActive === activeBlock) {
            return;
        }

        this.state.blockActive = activeBlock;
        this.setItemActive(activeBlock);
        this.setTranslate(activeBlock);
        this.activateVideoBlock(activeBlock + 1);

        if (this.isMobile && activeBlock === 0) {
            (this.videos[0].video || this.videos[0].img).style.opacity = progress * 5;
        }
    },

    setInitialPosition: function () {
        this.state.isInitialPositionSet = true;

        if (this.isMobile) {
            return;
        }

        this.blocks.forEach((block, index) => {
            if (index === 0) {
                this.setTranslate(index);

                return;
            }

            block.$el.addClass(Constants.cssClasses.isHide);
            block.$el.removeClass(Constants.cssClasses.isActive);
            block.isActive = false;
            block.isShown = false;
        });
    },

    setLastPosition: function () {
        this.state.isLastPositionSet = true;

        if (this.isMobile) {
            return;
        }

        const length = this.blocks.length;
        this.blocks.forEach((block, index) => {
            if (index === length - 1) {
                this.setTranslate(index);

                return;
            }

            block.$title.css(Constants.cssProperties.opacity, 1);
            block.$description.css(Constants.cssProperties.opacity, 1);
            block.$el.removeClass(Constants.cssClasses.isHide);
            block.$el.removeClass(Constants.cssClasses.isActive);
            block.isActive = false;
            block.isShown = true;
        });
    },

    onResize: function () {
        if (!this.videos) {
            return;
        }

        this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        const wh = window.app.sizes.windowHeight;
        this.ww = window.app.sizes.windowWidth;

        if (this.isMobile) {
            this.itemsPos = [];
            let prevTop = this.$(Selectors.title).offset().top;
            let prevHeight = this.$(Selectors.title).height();
            const videoHeight = 230;
            this.$items.each((index, item) => {
                const top = $(item).offset().top;
                const height = $(item).height();
                let pos = {
                    start: Math.round(prevTop - wh / 2 + prevHeight / 2) - (index === 0 ? 300 : 0),
                    end: Math.round(top - wh / 2 + height / 2)
                };
                pos.minOpacityAtStart = Math.round(pos.start + videoHeight / 2 + 50);
                pos.progressStart = Math.round(pos.minOpacityAtStart + 50);

                pos.minOpacityAtEnd = Math.round(pos.end - videoHeight / 2 + 50);
                pos.progressEnd = Math.round(pos.minOpacityAtEnd - 50);

                this.itemsPos.push(pos);
                prevTop = top;
                prevHeight = height;
            });
        } else {
            this.blockHeight = this.$el.height();
            this.blockOffsetTop = this.$el.offset().top;
        }

        this.onScroll(window.pageYOffset);
    },

    activateVideoBlock: function (index) {
        const videoIndex = index - 1;

        if (!this.videos[videoIndex]) {
            return;
        }

        this.$(Selectors.sequenceVideoOrImg).css(Constants.cssProperties.opacity, 0);

        const item = this.videos[videoIndex].video || this.videos[videoIndex].img;

        if (videoIndex === 0) {
            return;
        }
        $(item).css(Constants.cssProperties.opacity, 1);
    },

    progressVideo: function (index, progress) {
        const videoObj = this.videos[index];

        if (progress === videoObj.progress) {
            return;
        }

        if (index === 0) {
            (videoObj.video || videoObj.img).style.opacity = progress * 5;
        }

        if (!videoObj.video) {
            return;
        }

        videoObj.progress = progress;
        videoObj.video.currentTime = videoObj.duration * progress;
    },

    createVideo: function (isFallback) {
        const params = {
            path: `${this.videoSequenceAssetsFolder}${VideoSequenceNamePattern}`,
            className: 'IndexTailored-video_'
        };

        this.videos = [];

        for (let i = 0; i <= 3; i++) {
            if (!isFallback) {
                let callbackForward = (() => {
                });

                const videoParams = {
                    path: `${params.path}${i}.mp4`,
                    $container: this.$sequenceWrapperInner,
                    className: `${params.className}${i}`,
                    callback: callbackForward
                };

                const video = app.utils.createVideoSequence(videoParams);

                const videoObj = {
                    video,
                    duration: VideoDurations[i],
                    progress: 0
                };

                this.videos.push(videoObj);
            } else {
                const img = $('<img>')
                    .addClass(`${params.className}${i}`)
                    .attr('src', `${params.path}${i}.jpg`)
                    .appendTo(this.$sequenceWrapperInner)[0];

                const imgObj = {
                    img
                };

                this.videos.push(imgObj);
            }
        }
    }
});
